import * as angular from 'angular';
import { CreditGapCoursePickerModal } from './credit-gap-course-picker-modal.service';
import { FindACourseTableModule } from './find-a-course-table-component/find-a-course-table.module';

export const FindACourseModalModuleNew = angular
  .module('credit-gaps-course-picker-modal', [FindACourseTableModule])
  .service('CreditGapCoursePickerModal', CreditGapCoursePickerModal).name;
